import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth, homeFor } from "../../context/AuthContext";
import { API, errMsg } from "../../lib/api";
import { Field, ErrBox } from "../../components/common";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const [forgot, setForgot] = useState(false);
  const [forgotMsg, setForgotMsg] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      const user = await login(email, password);
      navigate(homeFor(user));
    } catch (e2) { setErr(errMsg(e2)); }
    setBusy(false);
  };

  const sendReset = async (e) => {
    e.preventDefault();
    setBusy(true); setErr(""); setForgotMsg("");
    try {
      const { data } = await API.post("/auth/forgot-password", { email });
      setForgotMsg(data.message);
    } catch (e2) { setErr(errMsg(e2)); }
    setBusy(false);
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-100 px-4">
      <div className="hero-grid absolute inset-0" />
      <div className="relative w-full max-w-md">
        <div className="mb-6 text-center">
          <Link to="/"><img src="/logo.png" alt="AZ Tax Accounts" className="mx-auto h-20 w-20 rounded-full border-2 border-gold/60" /></Link>
          <h1 className="mt-4 text-2xl font-extrabold text-navy">AZ <span className="text-copper">TAX</span> ACCOUNTS</h1>
          <p className="text-xs font-semibold uppercase tracking-widest text-slate-500">Secure Sign In</p>
        </div>
        <div className="card-gov p-6">
          {!forgot ? (
            <form onSubmit={submit} className="space-y-4" data-testid="login-form">
              <Field label="Email"><input type="email" className="input-gov" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email" autoComplete="email" /></Field>
              <Field label="Password"><input type="password" className="input-gov" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password" autoComplete="current-password" /></Field>
              <ErrBox msg={err} />
              <button className="btn-navy w-full py-2.5" disabled={busy} data-testid="login-submit">{busy ? "Signing in…" : "Sign In"}</button>
              <div className="flex items-center justify-between text-sm">
                <button type="button" onClick={() => setForgot(true)} className="font-semibold text-navy hover:underline" data-testid="forgot-password-link">Forgot password?</button>
                <Link to="/register" className="font-semibold text-copper hover:underline" data-testid="login-register-link">Create account</Link>
              </div>
            </form>
          ) : (
            <form onSubmit={sendReset} className="space-y-4" data-testid="forgot-form">
              <p className="text-sm text-slate-600">Enter your account email and we'll send a reset link.</p>
              <Field label="Email"><input type="email" className="input-gov" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="forgot-email" /></Field>
              {forgotMsg && <div className="rounded-md border border-emerald-200 bg-emerald-50 px-3 py-2 text-sm text-emerald-800" data-testid="forgot-success">{forgotMsg}</div>}
              <ErrBox msg={err} />
              <button className="btn-navy w-full" disabled={busy} data-testid="forgot-submit">{busy ? "Sending…" : "Send Reset Link"}</button>
              <button type="button" onClick={() => setForgot(false)} className="w-full text-center text-sm font-semibold text-slate-500 hover:underline">Back to sign in</button>
            </form>
          )}
        </div>
        <p className="mt-4 text-center text-xs text-slate-400">Protected by rate limiting, session security, and full audit logging.</p>
      </div>
    </div>
  );
}
